import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, delay, tap } from 'rxjs/operators';
import { URI_APIs } from '@features/auth/const';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
import {
  IAuthentication,
  ILoginErrorBehavior,
  ILoginFormMobileCodeChallenge,
} from '@features/auth/core/domain/login/models/authentication.interface';
import {
  ILoginResponse,
  IRegisterLoginSessionResponse,
} from '../login/dto/login-response.interface';
import { AuthErrorModel } from '../login/models/version-2/auth-error-version2.model';
import { AuthMobileModel } from './models/auth-sso-mobile.model';
import { DecentralierService } from '../../auth-action/decentralization.services';

/**
 *
 */
@Injectable()
export class AuthSSOMobileService
  implements IAuthentication, ILoginErrorBehavior, ILoginFormMobileCodeChallenge {
  private readonly httpClient = inject(HttpClient);
  private readonly conf = inject(CoreAuthConfigService);
  private readonly detranalizerService = inject(DecentralierService);

  authEvent: Subject<any> = new Subject<any>();
  authEvent$: Observable<any> = this.authEvent.asObservable();

  private authModel!: AuthMobileModel;

  constructor() {
    this.authModel = new AuthMobileModel();
  }

  /**
   *
   * @param code_challenge
   * @param clientId  App key.
   */
  registerLoginSession(code_challenge: string, clientId: string, redirect_uri: string): Observable<any> {
    // return of(throwError(() => new Error('Not implemented')));
    const url = this.conf.buildURL(URI_APIs.SSO_MOBILE_REGISTER_LOGIN_SESSION);
    const requestBody: any = {
      code_challenge: code_challenge,
      clientId: clientId ?? '',
      redirect_uri: redirect_uri ?? '',
    };

    return this.httpClient.post<IRegisterLoginSessionResponse>(url, requestBody);
  }

  resetAppKey(typeAccount: string): void {
    if (typeAccount) {
      StorageHelper.setAppKey(typeAccount);
    } else {
      StorageHelper.setAppKey(this.conf.applicationConfig.appKey ?? '');
    }
  }

  /**
   * Session id truyen tu app mobile ()
   * @param username
   * @param password
   * @param typeAccount
   * @param session_id
   * @returns
   */
  login(
    username: string,
    password: string,
    typeAccount: string,
    code_challenge?: string,
  ): Observable<AuthMobileModel> {
    if (username?.trim().length == 0 || password.trim().length == 0) {
      throw new Error(`Username and password should not be empty`);
    }
    // Khong can reset app key - vi page login sso khong dung app key tu form.
    // this.resetAppKey(typeAccount);
    const url = this.conf.buildURL(URI_APIs.SSO_MOBILE_LOGIN_NORMAL);

    const requestBody: any = {
      username: username,
      password: password,
      loai_tai_khoan: typeAccount,
      code_challenge: code_challenge ?? '',
    };

    const response = this.httpClient.post<ILoginResponse>(url, requestBody);

    return response.pipe(
      catchError((err) => {
        this.countLoginError();
        this.authEvent.next({ key: 'LOGIN_ERROR', value: err });
        return throwError(() => AuthErrorModel.handle(err));
        // return of(this.authModel.mapDataFromAPI({ authorization_code: '10983209128093', redirect_uri: 'http://mobile' }));
        //
      }),
      map((response: any) => {
        return this.authModel.mapDataFromAPI(response);
      }),
      // lưu token và thông tin user phục vụ việc lấy dữ liệu từ server và hiển thị thông tin user
      tap((formated) => {
        this.authEvent.next({ key: 'LOGIN', value: formated });
        StorageHelper.setSSOMobileAuthorizationCode(formated.authorization_code ?? '');
        this.clearLoginCountError();
      }),
    );
  }

  logout() {
    return throwError(() => new Error('Method not implemented.'));
  }
  clearLocalStorageItem = () => {
    StorageHelper.emptySessionAndLocalStorage();
    this.detranalizerService.setElements([]); // <--- Clear active element in state;
  };

  countLoginError() {
    let countLoginError = +this.getLoginCountError();
    if (countLoginError) {
      countLoginError += 1;
    } else {
      countLoginError = 1;
    }
    StorageHelper.storeLoginCountError(countLoginError);
    return countLoginError;
  }

  getLoginCountError() {
    return +StorageHelper.getLoginCountError();
  }

  clearLoginCountError() {
    StorageHelper.storeLoginCountError(0);
  }

  isLoggedIn = (): boolean => {
    throw new Error('Method not implemented.');
  };

  getAccessToken = () => {
    throw new Error('Method not implemented.');
  };

  buildTokenByJWTPrefix = (type: string = 'JWT') => {
    return `${type} ${this.getAccessToken()}`;
  };

  register(info: any): Observable<any> {
    return of(false);
  }
}
